export default "__VITE_ASSET__Cs_ry_uj__"